import { Box, CircularProgress } from "@mui/material";
import React from "react";

function CircularComponent(props) {
  return (
    <Box
      sx={{
        position: "absolute",
        width: "100%",
        // height: "100%",
        display: "flex",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </Box>
  );
}

export default CircularComponent;
